/*
+------------------------------------------------------------------------------+
+ Helper module for Dbacks Terms and Conditions
+
+
+
+
+
+ 
+
+------------------------------------------------------------------------------+ */

import { NotificationModal } from "@/shared/common/InfoPopup/NotificationModal";
import { createJsxLink } from "../utils/utils.dom";
import { createState } from "../store/zustand_store";
import { Box, ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import { useAppStore } from "../store";
import { selectUser } from "../store/data/user";
import Link from "next/link";

export function DbacksTCLanguage() {
  return (
    <>
      In connection with your purchase, you will receive ticket-related
      commercial emails from dbacks.com. You may unsubscribe at any time. By
      checking this box you agree to receive additional commercial emails from
      dbacks.com and MLB.com. The terms and conditions of your ticket and
      policies applicable to its use are updated to address circumstances
      related to COVID-19 and health and safety. Further, due to the COVID-19
      pandemic, scheduling may be impacted; games may be canceled, rescheduled,
      or postponed or games may be held with limited capacity. Upon completing
      your purchase by selecting Purchase Tickets you acknowledge and agree that
      your credit card will be charged. By clicking “Purchase Tickets”, you
      agree to the{" "}
      {createJsxLink(
        "MLB Privacy Policy",
        "https://www.mlb.com/app/ballpark/official-information/privacy-policy"
      )}
      ,{" "}
      {createJsxLink(
        "Terms of Use",
        "https://www.mlb.com/app/ballpark/official-information/terms-of-use"
      )}{" "}
      and to receive your ticket(s) via an SMS text message to the mobile #
      associated with your Diamondbacks account. Message and data rates may
      apply Tickets will be made available in the MLB Ballpark mobile
      application only. MLB.com and supported mobile device required.
    </>
  );
}

export const useDbacksTcModal = createState({
  isOpen: false,
});

export function DbacksTcModal() {
  const termsModal = useDbacksTcModal();

  return (
    <NotificationModal
      isOpen={termsModal.isOpen}
      title="Terms And Conditions"
      description={
        <Box maxHeight={"550px"} overflow={"auto"}>
          <DbacksTCLanguage />
        </Box>
      }
      hideTitleIcon
      primaryButtonText="Close"
      onClose={() => termsModal.set({ isOpen: false })}
      onClickPrimaryButton={() => termsModal.set({ isOpen: false })}
      hideSecondaryButton
    />
  );
}

export function DbacksHamburgerTCListItems() {
  const user = useAppStore(selectUser);
  const termsModal = useDbacksTcModal();

  return (
    <Box>
      <MenuItem
        onClick={() => {
          window.open(
            "https://www.mlb.com/app/ballpark/official-information/privacy-policy",
            "_blank"
          );
        }}
      >
        <ListItemIcon>
          <OpenInNewRoundedIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>MLB Privacy Policy</ListItemText>
      </MenuItem>

      <MenuItem
        onClick={() => {
          window.open(
            "https://www.mlb.com/app/ballpark/official-information/terms-of-use",
            "_blank"
          );
        }}
      >
        <ListItemIcon>
          <OpenInNewRoundedIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>MLB Terms of Use</ListItemText>
      </MenuItem>
    </Box>
  );
}

export function DbacksAdditionalDetailsDisclaimerTC() {
  return (
    <>
      By entering my name, checking the box above and clicking Submit Request, I
      hereby (i) agree to the 
      <Link
        href={"https://www.mlb.com/dbacks/tickets/premium/suites/use-agreement"}
        target="_blank"
      >
        Terms of Use
      </Link>{" "}
      (ii) agree that my reservation will not be complete unless and until I
      receive a notice from Arizona Diamondbacks confirming whether or not my
      reservation has been accepted in accordance with our agreement.
    </>
  );
}
